import React, { useEffect, useRef, useState } from 'react';
import {
    BrowserRouter as Router,
    matchPath, Redirect, Route, Switch
} from "react-router-dom";
import BetradarWidgetS5Component from './common/BetradarWidgetS5Component';
import BetslipVariation from './data/betslip/BetslipVariation';
import PurchaseResponseMessage from './data/betslip/PurchaseResponseMessage';
import ControlPanelItems from './common/control-panel-items/ControlPanelItems';
import FastbetPopup from './common/fastbet/FastbetPopup';
import HeaderMenu from './common/HeaderMenu';
import AppModal from './data/modal/AppModal';
import ReservationDetailPopup from './common/ReservationDetailPopup';
import ShowCheckBet from './common/ShowCheckBet';
import MainContext from './contexts/MainContext';
import BetslipConf from './data/betslip/BetslipConf';
import BonusConf from './data/betslip/BonusConf';
import UserConf from './data/betslip/UserConf';
import ControlPanelConf from './data/control-panel-context/ControlPanelConf';
import FastbetConf from './data/fastbet/FastbetConf';
import LandingRequestedOpsConf from './data/landing/LandingRequestedOpsConf';
import CheckSystemBets from './data/my-bets/checksystembets/CheckSystemBets';
import MyBets from './data/my-bets/MyBets';
import ShopReceiptPrinterConf from './data/printer/ShopReceiptPrinterConf';
import TicketPrinterConf from './data/printer/TicketPrinterConf';
import PvrConf from './data/pvr/PvrConf';
import { SeoContext, useSeoContext } from './data/seo/SeoContextProvider';
import { fetchSeoConfig, handleCanonicalUrl } from './data/seo/seoUtils';
import ShopConf from './data/shop/ShopConf';
import { getQueryStringVariable } from './data/utils';
import InitData, { appConfig, getLabel } from './InitData';
import Live from './live/Live';
import PageData from './PageData';
import Prematch from './prematch/Prematch';
import PrematchDataFetcher from './prematch/PrematchDataFetcher';
import RouteSeoPath from './RouteSeoPath';
import UISettingsProvider from './UISettingsProvider';
import ProgressBarContainer from './data/progress-bar/ProgressBarContainer';
import CashoutConfigurationCtx from './data/cashout/CashoutConfigurationCtx';
import WidgetContextProvider from './WidgetContextProvider';
import { systemCode } from '.';
import BetOptionsModalContent from './data/betslip/BetOptionsModalContent';
import { concatUrlPathnames } from './data/sport-utils';
import LoadBet from './common/loadbet/LoadBet';
import BetslipSelectionsConf from './data/betslip/BetslipSelectionsConf';
import { isMatchBetgeniusV3Streaming } from './data/streaming/streamingUtils';
import TimelineProvider from './prematch/TimelineProvider';
import CountryZoneModal from './common/country-zone/CountryZoneModal';
import ConfirmModalContent from './data/modal/ConfirmModalContent';

export function isLiveSection(section) {
    return ((appConfig.ROUTES['live'][section] || null) != null) || 'live' === section;
}

function Main() {
    const [seoConfigFetched, setSeoConfigFetched] = useState(false);
    const [isLive, setIsLive] = useState(false);
    const [location, setLocation] = useState(null);
    const [seoContext] = useSeoContext();
    const ctxRef = useRef({}).current;
    const [context, setContext] = useState({
        currentSection: useRef(null),
        seoRoutePath: {},
        data: null,
        matchData: null,
        streamingId:null,
        streamingMatchid:null,
        streamingContainer:null,
        streamingProps:null,
        reloadPrematch: useRef(null).current,
        historyNavigationEnabled: (systemCode == 'NETBET' || systemCode == 'SPIN.RO'  || systemCode == 'WILLIAMHILL'),
        historyBackPressed:false,
        prematchHistoryBackPressed: false,
        showFastbetPopup: false,
        prematchEventToOpen: null,
        betslipLandingData: null,
        betslipVariationData: null,
        purchaseResponseData: null,
        livePurchaseProgressBar: null,
        confirmModalData: null,
        hideMenu: isHideMenu(),
        hideBetslip: isHideBetslip(),
        update(updt) {
            setContext(prev => {
                return {...prev, ...updt};
            });
        },
        setCurrentSection(section) {
            this.currentSection.current = section;
            document.querySelector('body')?.setAttribute("data-xsport-section",section);
        },
        setSeoRoutePath(seoPathname, defaultPathname) {
            this.update({seoRoutePath: JSON.parse(`{"${seoPathname}":"${defaultPathname}"}`)});
        },
        setHistoryBackPressed(historyBackPressed,s) {
            this.historyBackPressed = historyBackPressed;
            this.update({historyBackPressed});
            if (s) {
                setLocation(s);
                setIsLive(isLiveSection(s));
            } else {
                setLocation(null);
                setIsLive(null);
            }
        },
        setPrematchHistoryBackPressed(prematchHistoryBackPressed) {
            this.update({prematchHistoryBackPressed});
        },
        setMatchData(matchData, isLive) {
            setIsLive(isLive);
            this.update({
                matchData
            });
        },
        setData(data) {
            this.update({
                data
            });
        },
        removeStreaming() {
             ctxRef.mainContext.update({
                streamingId: null,
                streamingMatchId: null
            });
        },
        showStreaming(streamingProps,streamingId, streamingMatchId, container) {
             ctxRef.mainContext.update({
                streamingId: ctxRef.mainContext.streamingId === streamingId ? null : streamingId,
                streamingMatchId: ctxRef.mainContext.streamingMatchId === streamingMatchId ? null : streamingMatchId,
                streamingContainer:container,
                streamingProps:streamingProps
            });       
        },
        toggleStreaming(streamingProps,streamingId, streamingMatchId, container='competition') {
			if (ctxRef.mainContext.streamingId === streamingId || ctxRef.mainContext.streamingMatchId === streamingMatchId) {
				ctxRef.mainContext.removeStreaming();
			} else {
				if (isMatchBetgeniusV3Streaming(streamingProps) && ctxRef.mainContext.streamingId !== streamingId) {
					// first remove the iframe, then wait some time to mount the new one
					ctxRef.mainContext.removeStreaming();
					setTimeout(() => {
						ctxRef.mainContext.showStreaming(streamingProps,streamingId, streamingMatchId, container);
					}, 100);
				} else {
					ctxRef.mainContext.showStreaming(streamingProps,streamingId, streamingMatchId, container);
				}
			}
        },
        setStreamingContainer(container='competition') {
            this.update({
                streamingContainer:container
            });
        },
        toggleFastbetPopup() {
            this.update({showFastbetPopup: !this.showFastbetPopup});
        },
        openPrematchEvent: function(prematchEventToOpen) {
        	this.prematchEventToOpen = prematchEventToOpen;
            this.update({
            	prematchEventToOpen
            });
        },
        setPrematchEventOpened: function() {
        	const prematchEventToOpen = null;
        	this.prematchEventToOpen = prematchEventToOpen;
            this.update({
            	prematchEventToOpen
            });
        },
        showBetslipVariationModal: function (selections, advise, purchaseFunction, amountData, returnToBetslipFunction) {
			const betslipVariationData = {
					selections,
					advise,
					purchaseFunction,
					amountData,
					returnToBetslipFunction
			}
			this.update({betslipVariationData});
		},
		hideBetslipVariationModal: function() {
			const betslipVariationData = null;
			this.update({betslipVariationData});
		},
        showBetOptionsModal: function (options, type, checkedValue, selectorFunction) {
			const labelLeft = type === 'freebet' ? 'carrello.freebet.title_part1' : 'carrello.fun_bonus.title_part1';
			const labelRight = type === 'freebet' ? 'carrello.freebet.title_part2' : 'carrello.fun_bonus.title_part2';
			const modalHeader = [getLabel(labelLeft), getLabel(labelRight).toUpperCase()].join(' ');
			const betOptionsData = {
					options,
					type,
					checkedValue,
					selectorFunction,
					modalHeader
			}
			this.update({betOptionsData});
		},
		hideBetOptionsModal: function() {
			const betOptionsData = null;
			this.update({betOptionsData});
		},
        showPurchaseMessageModal: function(message, type) {
			const purchaseResponseData = {
				message,
				type
			};
			this.update({purchaseResponseData});
		},
        hidePurchaseMessageModal: function () {
			const purchaseResponseData = null;
			this.update({purchaseResponseData});
		},
        showLivePurchaseProgressBar: function(duration,message) {
			const livePurchaseProgressBar = {
				duration: duration,
                message: message
			};
			this.update({livePurchaseProgressBar});
		},
        hideLivePurchaseProgressBar: function () {
			const livePurchaseProgressBar = null;
			this.update({livePurchaseProgressBar});
		},
        showConfirmModal: function(title,message,onConfirmCallback,onCancelCallback) {
            const confirmModalData = {
                title: title,
                message: message,
                onConfirm: onConfirmCallback,
                onCancel: onCancelCallback
            }
            this.update({confirmModalData});
        },
        hideConfirmModal: function() {
            const confirmModalData = null;
            this.update({confirmModalData});
        },
    });

	ctxRef.mainContext = context;
    useEffect(function() {
        if (location != null) {
            handleSelectButton(location);
        }
    }, [location]);
    
    useEffect(function() {
       if (context.prematchEventToOpen) {
    	   setIsLive(false);
    	   setLocation('top-match');
       }
    }, [context.prematchEventToOpen]);

    useEffect(function() {
        if (!window.showBetslipVariationModal) {
            window.showBetslipVariationModal = function(selections, advise, purchaseFunction, amountData, returnToBetslipFunction) {
               context.showBetslipVariationModal(selections, advise, purchaseFunction, amountData, returnToBetslipFunction);			
            }
        }
        
        if (!window.showBetOptionsModal) {
            window.showBetOptionsModal = function(options, type, checkedValue, selectorFunction) {
               context.showBetOptionsModal(options, type, checkedValue, selectorFunction);			
            }
        }
        if (!window.hideBetOptionsModal) {
            window.hideBetOptionsModal = function() {
               context.hideBetOptionsModal();		
            }
        }
        if (!window.showModalPurchaseMessage) {
            window.showModalPurchaseMessage = function(message, type) {
               context.showPurchaseMessageModal(message, type);		
            }
        }

        if (!window.hideModalPurchaseMessage) {
            window.hideModalPurchaseMessage = function() {
               context.hidePurchaseMessageModal();		
            }
        }

        if (!window.showLivePurchaseProgressBar) {
            window.showLivePurchaseProgressBar = function(duration,message) {
               context.showLivePurchaseProgressBar(duration,message);		
            }
        }
        if (!window.hideLivePurchaseProgressBar) {
            window.hideLivePurchaseProgressBar = function() {
               context.hideLivePurchaseProgressBar();		
            }
        }
        if (!window.showConfirmModal) {
            window.showConfirmModal = function(title,message,onConfirmCallback,onCancelCallback) {
               context.showConfirmModal(title,message,onConfirmCallback,onCancelCallback);			
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    window.openSection = function(section,callback) {
        if (!isLive && !isLiveSection(section) && context.reloadPrematch) {
            context.reloadPrematch();
            if (context.historyNavigationEnabled) {
                setLocation(section);
            }
            return;
        } else {
            context.reloadPrematch = null;
        }

        setIsLive(isLiveSection(section));

        if (section.localeCompare('prematch') === 0) {
            section = 'top-match';  // prematch default
        } else if (section.localeCompare('live') === 0) {
            section = 'multi-bet';     // live default
        }

        if (context.historyNavigationEnabled) {
            seoContext.setRefreshMetas(true);
        }
        setLocation(section);
        if (callback) {
            callback();
        }
    }
    
    const prevLocationHash = useRef(window.location.hash).current;
    window.onhashchange = function(e) {
        const section = window.location.hash.replace('#', '');
        if (section.startsWith('/prematch')) {
            const subsection = section.replace('/prematch/', '');
            if (subsection !== '' && subsection !== '/prematch') {
                window.openSection(subsection);
            } else {
                window.openSection('prematch');
            }
        } else if (section.startsWith('/live')) {
            window.openSection('live');
        }
    }
    
    function handleSelectButton(section) {
        const selectMenuButton = window.appConfig.HANDLERS?.['selectMenuButton'];
        if (typeof selectMenuButton === 'function') {
            selectMenuButton(section);
        }
    }

    function handleOpenFromPath(matchingRoute, location) {
        if (window.location.hash && ( (prevLocationHash !== window.location.hash))) {// Se # su URL cambia non faccio nulla
            return null;
        }
        const open = {};
        const last = location.pathname.substring((location.pathname.lastIndexOf('/')));

        const suffix = last && last.match(/(_-?\d+){1,5}/gm);
        const parts = suffix?.[0]?.split("_") || [];
        parts.splice(0, 1); 
       
        switch (parts.length) {
            case 1: 
                open.sport = {
                    sportId: parts[0]
                }
                break;
            case 2: 
                open.country = {
                     sportId: parts[0],
                    countryId: parts[1]
                }
                break;
            case 3: 
                open.tournament = {
                    sportId: parts[0],
                    countryId: parts[1],
                    tournamentId: parts[2]
                }
                break;
            case 5: 
                open.tournament = {
                    sportId: parts[0],
                    countryId: parts[1],
                    tournamentId: parts[2]
                }
                open.match = {
                    pal: parts[3],
                    avv: parts[4]
                }
                break;
            default:
                return null;
        }

        if (last?.replace(suffix,"").endsWith("_live")) {
            open.isLive = true;
        }

        return open;
    }

    function setSeoPathName(pathname, location) {
        if (pathname) {
            if (location) {
                const locationPathname = isLiveSection(location) ? appConfig.ROUTES['live'][location] : (appConfig.ROUTES['prematch'][location] || appConfig.ROUTES['checkbet'][location] || appConfig.ROUTES['checksystembets'][location]);
                const index = pathname.indexOf(locationPathname)+locationPathname.length
                if (pathname.substring(index)) {
                    seoContext.setPathname(pathname.replace(locationPathname,''),location);
                } else {
                    seoContext.setPathname(pathname,location);
                }
            } else {
                seoContext.setPathname(pathname,location);
            }
        }
    }

    function routePrematch(props) {
        const openFromPath = handleOpenFromPath(props.match,props.location);

        if (openFromPath?.isLive) {
            return routeLive(props,openFromPath);
        }

        const s = location || appConfig.ROUTES.sectionFromPath(props.match.url,appConfig.ROUTES['prematch']);
        if (context.currentSection.current !== seoContext.location) {
            setSeoPathName(props.location.pathname, s);
        }
        context.setCurrentSection(s);
        handleSelectButton(s);

        return (
            <>
                {(location == null || !isLive) &&
                    <PrematchDataFetcher>
                        <Prematch section={s} openFromPath={openFromPath} pathname={props.location.pathname} />
                    </PrematchDataFetcher>
                }
            </>
        );
    }

    function routeLive(props,openFromPath) {
        const s = location || appConfig.ROUTES.sectionFromPath(props.match.url,appConfig.ROUTES['live']) ||  openFromPath?.isLive && 'live-suite';
        if (context.currentSection.current !== seoContext.location) {
            setSeoPathName(props.location.pathname, s);
        }
        context.setCurrentSection(s);
        handleSelectButton(s);
        return (
            location===null || isLive ?
                <Live section={s} openFromPath={openFromPath} />
                :
                <></>
        );
    }

    function routeMybets(props) {
        const s = location || appConfig.ROUTES.sectionFromPath(props.match.url,appConfig.ROUTES['mybets']);
        context.setCurrentSection(s);
        return (
            <MyBets />
        );
    }

    function routeCheckbet(props) {
        const s = location || appConfig.ROUTES.sectionFromPath(props.match.url,appConfig.ROUTES['checkbet']);
        context.setCurrentSection(s);
        setSeoPathName(props.location.pathname, s);
        return (
            <ShowCheckBet />
        );
    }

    function routeLoadbet() {
        return (
            <LoadBet />
        );
    }

    function routeCheckSystemBets(props) {
        const s = location || appConfig.ROUTES.sectionFromPath(props.match.url,appConfig.ROUTES['checksystembets']);
        context.setCurrentSection(s);
        setSeoPathName(props.location.pathname, s);
        return (
            <CheckSystemBets />
        );
    }

    function routeBetradarWidget(props) {
        const s = location || appConfig.ROUTES.sectionFromPath(props.match.url,appConfig.ROUTES['betradar-widget']);
        context.setCurrentSection(s);
        return (
            <BetradarWidgetS5Component />
        );
    }

    function routeSeoPath(props) {
        return (
            <RouteSeoPath {...props} />
        );
    }

    function isSeoOff() {
        return (getQueryStringVariable('seoOff') == 'true' || getQueryStringVariable('seoDisabled') == 'true' || (appConfig && appConfig['seoOff'] == true)) ? true : false;
    }

    function isHideMenu() {
        return getQueryStringVariable('hideMenu') == 'true';
    }

    function isHideBetslip() {
        return getQueryStringVariable('hideBetslip') == 'true';
    }

    useEffect(function() {
        if ((!(window.cg_SYSTEM_CODE || window.appConfig.SHOP_MODE ) && !isSeoOff() ) || (appConfig && appConfig['SEO_ENABLED'])) {
            try {
                fetchSeoConfig(setSeoConfigFetched, false);
            } catch(err) {
                setSeoConfigFetched(true);
                console.log(err);
                alert(err);
            }
        } else {
            setSeoConfigFetched(true);
        }
    }, []);

    if (seoConfigFetched && appConfig?.ROUTES?.['live'] && !appConfig.ROUTES['live']?.['agenda'] ) {
        appConfig.ROUTES['live']['agenda'] = concatUrlPathnames(appConfig.ROUTES['live']?.['live-suite'],'agenda')
    }

    function useHandleHistoryNavigation() {
        useEffect(() => {
            if (context.historyNavigationEnabled) {
                window.addEventListener('popstate', (event) => {
                    let pathname = window.location.pathname;
                    pathname = pathname.substring(pathname.indexOf(appConfig.BASENAME) + appConfig.BASENAME.length);
                    let s = appConfig.ROUTES.sectionFromPath(pathname,appConfig.ROUTES['prematch']);
                    if (!s) {
                        s = appConfig.ROUTES.sectionFromPath(pathname,appConfig.ROUTES['live']);
                    }
                    context.setHistoryBackPressed(true,s);
                });
            }
        }, []);

        useEffect(() => {
            if (context.historyBackPressed) {
                 const internalPathname = context.seoRoutePath[window.location.pathname];
                 if (internalPathname && seoContext.pathname != internalPathname ) {
                     seoContext.refreshPathname(internalPathname,context.currentSection.current,false);
                     handleCanonicalUrl(window.location.pathname);
                     //seoContext.setRefreshMetas(false);
                 }
                 //context.setHistoryBackPressed(false);
            }
         }, [context.seoRoutePath,window.location.pathname]);
     
         useEffect(() => {
            if (context.historyBackPressed) {
                let pathname = window.location.pathname;
                pathname = pathname.substring(pathname.indexOf(appConfig.BASENAME) + appConfig.BASENAME.length);
                let s = appConfig.ROUTES.sectionFromPath(pathname,appConfig.ROUTES['prematch']);
                if (s == 'top-match') {
                    context.setPrematchHistoryBackPressed(true);
                }
                setTimeout(() => {
                    context.setHistoryBackPressed(false);
                }, 50);
            }
          }, [context.historyBackPressed]);
     
         useEffect(() => {
             if (context.prematchHistoryBackPressed) {
                 context.setPrematchHistoryBackPressed(false);
             }
          }, [context.prematchHistoryBackPressed]);
    }

    useHandleHistoryNavigation();
    window.testProgressBar = function(duration,message) {
        window.showLivePurchaseProgressBar(duration || 5000, message || 'Test progressbar');
    }

    //For paths ending with '/', adding also path without '/'
    //For paths not ending with '/', adding also path with '/'
    if (appConfig?.URL_PATH_MAPPINGS) {
        try {
            Object.keys(appConfig.URL_PATH_MAPPINGS).forEach(p => {
                if (p?.endsWith('/') && appConfig.ROUTES.routeFromPath (p)) {
                    const m = p.substring(0, p.length-1)
                    if (!appConfig.URL_PATH_MAPPINGS[m]) {
                        appConfig.URL_PATH_MAPPINGS[m] = appConfig.URL_PATH_MAPPINGS[p];
                    }
                } else {
                    const m = concatUrlPathnames(p, '/');
                    if (!appConfig.URL_PATH_MAPPINGS[m]) {
                        appConfig.URL_PATH_MAPPINGS[m] = appConfig.URL_PATH_MAPPINGS[p];
                    }
                }
            });
        } catch(err) {
            console.log(err);
        }
    }

    const routes = appConfig.ROUTES;
    const mappings = appConfig.URL_PATH_MAPPINGS;

    //routes['prematch']['today-odds'] = '/scommesse/g/oggi'

    return (
        <InitData>
            <TimelineProvider>
                <PageData>
                    <MainContext.Provider value={context}>
                        <LandingRequestedOpsConf section={context.currentSection.current}>
                            <ShopReceiptPrinterConf>
                                <ShopConf useSocket={false}>
                                    <CashoutConfigurationCtx>
                                        <PvrConf>
                                            <UserConf frontendVersion={"desktop"}>
                                                <ControlPanelConf>
                                                    <TicketPrinterConf>
                                                        <ControlPanelItems />
                                                        <FastbetConf>
                                                            <BonusConf>
                                                                <BetslipConf doubleProfileDefaultChoice={window.appConfig ? window.appConfig.doubleProfileDefaultChoice : null} >
                                                                <BetslipSelectionsConf  >
                                                                    <WidgetContextProvider location={location}>
                                                                        <SeoContext.Provider value={seoContext}>
                                                                            <UISettingsProvider section={context.currentSection.current}>
                                                                                {!context.hideMenu && 
                                                                                    <HeaderMenu section={context.currentSection.current} />
                                                                                }
                                                                                {context.betOptionsData &&
                                                                                    <AppModal closeFunction={() => {context.hideBetOptionsModal()}} uncloseable={false} modalHeader={context.betOptionsData.modalHeader} modalContent={<BetOptionsModalContent betOptionsData={context.betOptionsData} closeFunction={() => {context.hideBetOptionsModal()}}/>} />
                                                                                }
                                                                                {context.betslipVariationData && 
                                                                                    <AppModal uncloseable={true} modalHeader={getLabel('carrello.var_quota.warning')} modalContent={<BetslipVariation betslipVariationData={context.betslipVariationData} closeFunction={() => {context.hideBetslipVariationModal()}}/>} />
                                                                                }
                                                                                {context.purchaseResponseData && 
                                                                                    <AppModal type={context.purchaseResponseData?.type} uncloseable={context.purchaseResponseData?.type == 'acceptance'} modalHeader={getLabel('general.message')} modalContent={<PurchaseResponseMessage purchaseResponseData={context.purchaseResponseData} />} closeFunction={() => {context.hidePurchaseMessageModal()}} />
                                                                                }
                                                                                {context.livePurchaseProgressBar && 
                                                                                    <AppModal uncloseable={true} transparentBackdrop={true} modalHeader={context.livePurchaseProgressBar.message}  modalContent={<ProgressBarContainer duration={context.livePurchaseProgressBar.duration} downward={true} />}  />
                                                                                }
                                                                                {context.confirmModalData && 
                                                                                    <AppModal uncloseable={true} modalHeader={context.confirmModalData.title}  modalContent={<ConfirmModalContent message={context.confirmModalData.message} onConfirm={context.confirmModalData.onConfirm} onCancel={context.confirmModalData.onCancell} close={() =>{context.hideConfirmModal()}}  />}  />
                                                                                }
                                                                                {seoConfigFetched && !context.prematchHistoryBackPressed &&
                                                                                    <Router basename={appConfig.BASENAME} >
                                                                                        {function() {
                                                                                            const redirectTo = isLiveSection(location)?routes['live'][location]:routes['prematch'][location];
                                                                                            return location != null && redirectTo && <Redirect push={!context.historyBackPressed} to={redirectTo} />
                                                                                        }()}
                                                                                        <Switch>
                                                                                            <Route exact path="/" render={(props) => {
                                                                                                if (routes['prematch']['top-match'] === '/') {
                                                                                                    return routePrematch(props);
                                                                                                } else {
                                                                                                    return  <Redirect to={routes['prematch']['top-match']}/>
                                                                                                }
                                                                                            }}/>
                                                                                            {/* <Route exact path="/mybets" render={() => <MyBets />} />
                                                                                            <Route exact path="/checkbet" render={() => <CheckBet />} /> */}
                                                                                            {mappings && 
                                                                                                <Route exact path={Object.keys(mappings).map(function(k) {return k.replaceAll(/\(/gm,"\\(").replaceAll(/\)/gm,"\\)")})} render={(props) => {
                                                                                                    const prematchPath = matchPath(mappings[props.match.url], {
                                                                                                        path: Object.values(routes['prematch']),
                                                                                                        exact: false,
                                                                                                        strict: false
                                                                                                    });
                                                                                                    const prematchPathExact = matchPath(mappings[props.match.url], {
                                                                                                        path: Object.values(routes['prematch']),
                                                                                                        exact: true,
                                                                                                        strict: false
                                                                                                    });
                                                                                                    const livePath = matchPath(mappings[props.match.url], {
                                                                                                        path: Object.values(routes['live']),
                                                                                                        exact: false,
                                                                                                        strict: false
                                                                                                    });
        
                                                                                                    const mybetsPath = routes['mybets'] && matchPath(mappings[props.match.url], {
                                                                                                        path: Object.values(routes['mybets']),
                                                                                                        exact: false,
                                                                                                        strict: false
                                                                                                    });
        
                                                                                                    const checkbetPath = routes['checkbet'] && matchPath(mappings[props.match.url], {
                                                                                                        path: Object.values(routes['checkbet']),
                                                                                                        exact: false,
                                                                                                        strict: false
                                                                                                    });
        
                                                                                                    const checkSystemBetsPath = routes['checksystembets'] && matchPath(mappings[props.match.url], {
                                                                                                        path: Object.values(routes['checksystembets']),
                                                                                                        exact: false,
                                                                                                        strict: false
                                                                                                    });
        
                                                                                                    const betradarWidgetPath = routes['betradar-widget'] && matchPath(mappings[props.match.url], {
                                                                                                        path: Object.values(routes['betradar-widget']),
                                                                                                        exact: false,
                                                                                                        strict: false
                                                                                                    });
                                                    
                                                                                                    //Check live path first because may be that live page path is a sub-path of prematch page path (e.g. live=/scommesse/scommesse-live, prematch=/scommesse/)
                                                                                                    if (livePath) {
                                                                                                        props.location.pathname = mappings[props.match.url];
                                                                                                        props.match = livePath;
                                                                                                        return routeLive(props);
                                                                                                    }
                                                                                                    if (prematchPathExact) {
                                                                                                        props.location.pathname = mappings[props.match.url];
                                                                                                        props.match = prematchPathExact;
                                                                                                        return routePrematch(props);
                                                                                                    }
                                                                                                    if (prematchPath) {
                                                                                                        props.location.pathname = mappings[props.match.url];
                                                                                                        props.match = prematchPath;
                                                                                                        return routePrematch(props);
                                                                                                    }
                                                                                                    if (mybetsPath) {
                                                                                                        props.location.pathname = mappings[props.match.url];
                                                                                                        props.match = livePath;
                                                                                                        return routeMybets(props);
                                                                                                    }
                                                                                                    if (checkbetPath) {
                                                                                                        props.location.pathname = mappings[props.match.url];
                                                                                                        props.match = livePath;
                                                                                                        return routeCheckbet(props);
                                                                                                    }
                                                                                                    if (checkSystemBetsPath) {
                                                                                                        props.location.pathname = mappings[props.match.url];
                                                                                                        props.match = checkSystemBetsPath;
                                                                                                        return routeCheckSystemBets(props);
                                                                                                    }
                                                                                                    if (betradarWidgetPath) {
                                                                                                        props.location.pathname = mappings[props.match.url];
                                                                                                        props.match = betradarWidgetPath;
                                                                                                        return routeBetradarWidget(props);
                                                                                                    }
                                                                                                }}/>
                                                                                            }
                                                                                            <Route exact path={Object.values(routes['prematch'])} render={(props) => {
                                                                                                return routePrematch(props);
                                                                                            }}/>
                                                                                            <Route exact path={Object.values(routes['live'])} render={(props) => {
                                                                                                return routeLive(props);
                                                                                            }}/>
                                                                                            {routes['mybets'] && 
                                                                                                <Route exact path={Object.values(routes['mybets'])} render={(props) => {
                                                                                                    return routeMybets(props);
                                                                                                }}/>
                                                                                            }
                                                                                            {routes['checkbet'] &&
                                                                                                <Route exact path={Object.values(routes['checkbet'])} render={(props) => {
                                                                                                    return routeCheckbet(props);
                                                                                                }}/>
                                                                                            }
                                                                                            {concatUrlPathnames(routes['prematch']['top-match'], 'loadbet')} &&
                                                                                                <Route exact path={concatUrlPathnames(routes['prematch']['top-match'], 'loadbet')} render={(props) => {
                                                                                                    return routeLoadbet(props);
                                                                                                }}/>
                                                                                            {routes['checksystembets'] &&
                                                                                                <Route exact path={Object.values(routes['checksystembets'])} render={(props) => {
                                                                                                    return routeCheckSystemBets(props);
                                                                                                }}/>
                                                                                            }
                                                                                            {routes['betradar-widget'] &&
                                                                                                <Route exact path={Object.values(routes['betradar-widget'])} render={(props) => {
                                                                                                    return routeBetradarWidget(props);
                                                                                                }}/>
                                                                                            }
                                                                                            {/* <Route path={Object.values(routes['prematch'])} render={(props) => {
                                                                                                return routePrematch(props);
                                                                                            }}/> */}
                                                                                            <Route exact path={Object.keys(context.seoRoutePath).map(function(k) {return k.replaceAll(/\(/gm,"\\(").replaceAll(/\)/gm,"\\)")})} render={(props) => {
                                                                                                const originalPath = context.seoRoutePath[props.location.pathname]
                                                                                                const prematchPath = matchPath(originalPath, {
                                                                                                    path: Object.values(routes['prematch']),
                                                                                                    exact: false,
                                                                                                    strict: false
                                                                                                });
                                                                                                const livePath = matchPath(originalPath, {
                                                                                                    path: Object.values(routes['live']),
                                                                                                    exact: false,
                                                                                                    strict: false
                                                                                                });
        
                                                                                                const mybetsPath = routes['mybets'] && matchPath(originalPath, {
                                                                                                    path: Object.values(routes['mybets']),
                                                                                                    exact: false,
                                                                                                    strict: false
                                                                                                });
        
                                                                                                const checkbetPath = routes['checkbet'] && matchPath(originalPath, {
                                                                                                    path: Object.values(routes['checkbet']),
                                                                                                    exact: false,
                                                                                                    strict: false
                                                                                                });
        
                                                                                                const checkSystemBetsPath = routes['checksystembets'] && matchPath(originalPath, {
                                                                                                    path: Object.values(routes['checksystembets']),
                                                                                                    exact: false,
                                                                                                    strict: false
                                                                                                });
                                                            
                                                                                                if (prematchPath) {
                                                                                                    props.location.pathname = originalPath;
                                                                                                    props.match = prematchPath;
                                                                                                    return routePrematch(props);
                                                                                                }
                                                                                                if (livePath) {
                                                                                                    props.location.pathname = originalPath;
                                                                                                    props.match = livePath;
                                                                                                    return routeLive(props);
                                                                                                }
                                                                                                if (mybetsPath) {
                                                                                                    props.location.pathname = originalPath;
                                                                                                    props.match = livePath;
                                                                                                    return routeMybets(props);
                                                                                                }
                                                                                                if (checkbetPath) {
                                                                                                    props.location.pathname = originalPath;
                                                                                                    props.match = livePath;
                                                                                                    return routeCheckbet(props);
                                                                                                }
                                                                                                if (checkSystemBetsPath) {
                                                                                                    props.location.pathname = originalPath;
                                                                                                    props.match = checkSystemBetsPath;
                                                                                                    return routeCheckSystemBets(props);
                                                                                                }
                                                                                            }}/>
                                                                                            <Route path={'*'} render={(props) => {
                                                                                                const prematchPath = matchPath(props.match.url, {
                                                                                                    path: Object.values(routes['prematch']),
                                                                                                    exact: false,
                                                                                                    strict: false
                                                                                                });
                                                                                                if (prematchPath) {
                                                                                                    if (handleOpenFromPath(props.match,props.location)) {
                                                                                                        props.location.pathname = props.match.url;
                                                                                                        props.match = prematchPath;
                                                                                                        return routePrematch(props);
                                                                                                    } else {
                                                                                                        return seoConfigFetched && routeSeoPath(props);
                                                                                                    }
                                                                                                } else {
                                                                                                    return seoConfigFetched && routeSeoPath(props);
                                                                                                }
                                                                                            }}/>
                                                                                        </Switch>
                                                                                        <div id="popup-container"></div>
                                                                                        {context.showFastbetPopup &&
                                                                                            <FastbetPopup />
                                                                                        }
                                                                                        <ReservationDetailPopup />
                                                                                    </Router>
                                                                                }
                                                                                <CountryZoneModal />
                                                                            </UISettingsProvider>
                                                                        </SeoContext.Provider>
                                                                    </WidgetContextProvider>
                                                                </BetslipSelectionsConf>
                                                                </BetslipConf>
                                                            </BonusConf>
                                                        </FastbetConf>
                                                    </TicketPrinterConf>
                                                </ControlPanelConf>
                                            </UserConf>
                                        </PvrConf>
                                    </CashoutConfigurationCtx>
                                </ShopConf>
                            </ShopReceiptPrinterConf>
                        </LandingRequestedOpsConf>
                    </MainContext.Provider>
                </PageData>
            </TimelineProvider>
        </InitData>
    );
}

export default Main;